/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import {
    FaMinus,
    FaPlus,
    FaPencilAlt,
    FaRegEdit,
    FaRegTrashAlt,
    FaRegEye,
    FaBusinessTime,
    FaTimes,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import {
    Button,
    Input,
    InputGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Col,
    Button as RSButton,
    Label,
    Card,
    InputGroupText,
} from "reactstrap";
import { IoIosSend } from "react-icons/io";
import Multiselect from "multiselect-react-dropdown";

import CompanySelector from "ATSComponents/Common/CompanySelector";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";
import { useForm } from "react-hook-form";
import SuccessErrorPopup from "ATSComponents/Common/SuccessErrorPopup";

import deleteIcon from "../../assets/images/deleteIcon.png";
import documentIcon from "../../assets/images/documentIcon.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ArchivedJobOrders = () => {
    document.title = "ATS - Archived Job Orders";
   const navigate = useNavigate();

    // ---------- UI / feedback ----------
    const [errorMessage, setErrorMessage] = useState("");
    const [errorAlert, setErrorAlert] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const handleCloseErrorModal = () => setErrorAlert(false);

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "All",
    };

    // ---------- top-level job list ----------
    const [jobOrdersData, setJobOrdersData] = useState([]);
    const [loadingJobs, setLoadingJobs] = useState(false);
    const [selectedJobs, setSelectedJobs] = useState([]);

    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    // filter status & list
    const [jobStatusList, setJobStatusList] = useState([]);
    const [selectedStatusIdFilter, setSelectedStatusIdFilter] = useState("");

    // company
    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info") || "{}");
    const intialcompanyId = userInfos?.user_details?.companies_data?.[0]?.company_id ?? null;
    const loggedInUserId = userInfos?.user_details?.user_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);

    // ---------- candidate caches & per-job state ----------
    const [candidateDataMap, setCandidateDataMap] = useState({}); // jobId -> [candidates]
    const [loadingCandidatesMap, setLoadingCandidatesMap] = useState({}); // jobId -> bool

    // per-job pagination, per-job perPage, per-job total, per-job search
    const [currentPageMap, setCurrentPageMap] = useState({}); // jobId -> page
    const [perPageMap, setPerPageMap] = useState({}); // jobId -> perPage
    const [totalRowsMap, setTotalRowsMap] = useState({}); // jobId -> total
    const [searchMap, setSearchMap] = useState({}); // jobId -> last applied search

    // helper getters
    const getJobCurrentPage = (jobId) => currentPageMap[jobId] ?? 1;
    const getJobPerPage = (jobId) => perPageMap[jobId] ?? 10;
    const getJobTotalRows = (jobId) => totalRowsMap[jobId] ?? 0;

    // ---------- modals/other states ----------
    const [AddCandidateModal, setAddCandidateModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { register, getValues } = useForm();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedJobForUpload, setSelectedJobForUpload] = useState(null);
    console.log(selectedJobForUpload)

    // delete job modal
    const [showDeleteJobModal, setShowDeleteJobModal] = useState(false);
    const [showDeleteCandidateModal, setShowDeleteCandidateModal] = useState(false);
    const [candidateDeleteId, setcandidateDeleteId] = useState(null);
    const [CandidateDeleteLoader, setCandidateDeleteLoader] = useState(null);
    const [ViewCandidatePopupShow, setViewCandidatePopupShow] = useState(false);

    const [selectDate, setSelectDate] = useState();
    const dateChange = (date) => {
        setSelectDate(date)
    };

    const handleCandidateDlink = (data) => {
        console.log(data)
        setShowDeleteCandidateModal(true);
        setcandidateDeleteId(data.job_candidate_id)

    }
    const [jobToDelete, setJobToDelete] = useState(null);
    const [deleteLoader, setDeleteLoader] = useState(false);

    // send test modal
    const [showSendTestModal, setShowSendTestModal] = useState(false);
    const [sendTestJobId, setSendTestJobId] = useState(null);
    const [sendTestCandidateId, setSendTestCandidateId] = useState(null);

    // telephonic modal
    const [showTelephonicModal, setShowTelephonicModal] = useState(false);
    const [telephonicJob, setTelephonicJob] = useState(null);

    // HRMS modal
    const [showHrmsModal, setShowHrmsModal] = useState(false);
    const [hrmsPayload, setHrmsPayload] = useState(null);

    // status modal
    const [statusModal, setStatusModal] = useState(false);
    const [selectedJobForStatus, setSelectedJobForStatus] = useState(null);
    console.log(selectedJobForStatus)
    const [selectedStatusId, setSelectedStatusId] = useState("");

    // add-candidate multiselect state
    const [candidateListingData, setcandidateListingData] = useState([]);
    const [internalEmpSelectedValues1, setInternalEmpSelectedValues1] =
        useState([]);
    const [userDrop, setusersdrop] = useState([]);

    // ---------- initial fetches ----------
    useEffect(() => {
        fetchStatuses();
    }, []);

    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [joiningDate, setJoiningDate] = useState(new Date());

    const ViewCandidateInfo = (candidate) => {
        console.log(candidate, "candidate")
        setSelectedCandidate(candidate);
        setViewCandidatePopupShow(true);
    };
const [selectedCategoryName, setSelectedCategoryName] = useState("");
    useEffect(() => {
        if (companyId) {
            getJobOrders(companyId, 1, perPage);
        } else {
            // if companyId is not set, still try to fetch (depending on backend)
            getJobOrders(null, 1, perPage);
        }
    }, [companyId, selectedStatusIdFilter,selectedCategoryName]);

    // ---------- API helpers ----------

    // Build params object conditionally (only include if value exists)
    const buildParams = (obj) => {
        const params = {};
        Object.entries(obj).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== "") params[k] = v;
        });
        return params;
    };

    const fetchStatuses = async () => {
        try {
            const res = await axios.get("/api/v1/get-all-Job-status/");
            setJobStatusList(res.data.results || []);
        } catch (err) {
            console.error("Failed to fetch statuses", err);
        }
    };
    const [jobSearchText, setJobSearchText] = useState("");
    const handleJobSearch = async () => {
        setCurrentPage(1); // reset pagination
        await getJobOrders(companyId, 1, perPage);
    };
    const [testTypeList, setTestTypeList] = useState([]);
    useEffect(() => {
    const fetchTestTypes = async () => {
        try {
        const response = await axios.get("api/v1/test-types/");
        setTestTypeList(response.data);
        } catch (error) {
        console.error("Error fetching test types:", error);
        }
    };
    fetchTestTypes();
    }, []);
    const getCategoryNameById = (id) => {
        const category = testTypeList.find((item) => item.id == id)
        return category ? category.name : null;
    };
    const getJobOrders = async (companyIdParam, page = 1, size = perPage) => {
        setLoadingJobs(true);
        try {
            const params = buildParams({
                company_id: companyIdParam,
                page,
                size,
                status_id: selectedStatusIdFilter,
                // created_by: loggedInUserId,
                search: jobSearchText || "",
                archived_only:true,
                category_name: getCategoryNameById(selectedCategoryName),
            });

            const response = await axios.get(`/api/v1/create-job-order/`, { params });
            let data = response?.data?.results ?? [];

            if (!Array.isArray(data) && data) data = [data];

            data = data.map((j, idx) => ({
                id: j.id ?? j.job_id ?? j.job_order_id ?? idx + 1,
                ...j,
            }));

            setJobOrdersData(data);
            setTotalRows(response?.data?.count ?? data.length);
        } catch (err) {
            console.error("Error fetching job orders:", err);
            setJobOrdersData([]);
            setTotalRows(0);
        } finally {
            setLoadingJobs(false);
        }
    };

    const getCandidateDetails = async (
        jobId,
        page = 1,
        size = 10,
        search = ""
    ) => {
        console.log("candidate")
        try {
            setLoadingCandidatesMap((p) => ({ ...p, [jobId]: true }));

            const params = buildParams({
                job_id: jobId,
                page,
                size,
                company_id: companyId,
                search: search,
            });

            const response = await axios.get(
                `/api/v1/candidates/candidates-by-job/`,
                { params }
            );

            const candidates = Array.isArray(
                response?.data?.results?.candidates
            )
                ? response.data.results.candidates
                : [];

            const total = response?.data?.results?.count ?? candidates.length;

            const normalized = candidates.map((c, idx) => ({
                candidate_id: c.candidate_id ?? c.id ?? idx + 1,
                ...c,
            }));

            setCandidateDataMap((prev) => ({ ...prev, [jobId]: normalized }));
            setTotalRowsMap((prev) => ({ ...prev, [jobId]: total }));
            setPerPageMap((prev) => ({ ...prev, [jobId]: size }));
            setCurrentPageMap((prev) => ({ ...prev, [jobId]: page }));
            setSearchMap((prev) => ({ ...prev, [jobId]: search }));
        } catch (err) {
            console.error("Failed to fetch candidates for job", jobId, err);
            setCandidateDataMap((prev) => ({ ...prev, [jobId]: [] }));
            setTotalRowsMap((prev) => ({ ...prev, [jobId]: 0 }));
        } finally {
            setLoadingCandidatesMap((p) => ({ ...p, [jobId]: false }));
        }
    };

    // ---------- candidate pagination & search handlers (per-job) ----------
    const handleCandidateSearch = async (jobId, searchValue) => {
        const page = 1;
        const size = perPageMap[jobId] ?? 10;
        setSearchMap((p) => ({ ...p, [jobId]: searchValue }));
        await getCandidateDetails(jobId, page, size, searchValue);
    };

    const handlePageChangeForJob = async (jobId, page) => {
        const size = perPageMap[jobId] ?? 10;
        const search = searchMap[jobId] ?? "";
        setCurrentPageMap((p) => ({ ...p, [jobId]: page }));
        await getCandidateDetails(jobId, page, size, search);
    };

    const handlePerRowsChangeForJob = async (jobId, newPerPage, page) => {
        const search = searchMap[jobId] ?? "";
        if ((perPageMap[jobId] ?? 10) !== newPerPage) {
            setCurrentPageMap((p) => ({ ...p, [jobId]: 1 }));
            page = 1;
        }
        setPerPageMap((p) => ({
            ...p,
            [jobId]: newPerPage === -1 ? totalRowsMap[jobId] ?? 0 : newPerPage,
        }));
        await getCandidateDetails(
            jobId,
            page,
            newPerPage === -1 ? totalRowsMap[jobId] ?? 0 : newPerPage,
            search
        );
    };

    // ---------- file upload helpers (for Add Candidate modal) ----------
    const resumeparsinguploadfiles = (e) => {
        e.preventDefault();
        let files = [];
        if (e.dataTransfer?.files) files = Array.from(e.dataTransfer.files);
        else if (e.target?.files) files = Array.from(e.target.files);
        if (!files.length) return;

        const validFiles = files.filter((file) =>
            [".pdf", ".doc", ".docx"].some((ext) =>
                file.name.toLowerCase().endsWith(ext)
            )
        );

        setSelectedFiles((prev) => [
            ...prev,
            ...validFiles.filter((f) => !prev.some((p) => p.name === f.name)),
        ]);
    };
    // ✅ ADD THIS AT THE TOP WITH OTHER STATES
    const [activeTab, setActiveTab] = useState("upload");
    const handleSelect = (selectedList) => {
        console.log(selectedList)
        const ids = selectedList.map((item) => item?.candidate_id);
        console.log(ids)
        setusersdrop(ids);
        setInternalEmpSelectedValues1(selectedList);
        if (selectedList.length !== 0) {
            let temp = [];
            selectedList.map((itme, i) => {
                temp.push(itme.candidate_id);
            });
        } else {
        }
    };
    const getEmpTitleText1 = () => {
        return internalEmpSelectedValues1.map((item) => item.name).join(", ");
    };

    const getEmpDisplayText1 = () => {
        if (internalEmpSelectedValues1.length > 0) {
            var temp;
            temp = internalEmpSelectedValues1.length;
            return `${temp} items selected`;
        } else if (internalEmpSelectedValues1.length === 1) {
            return internalEmpSelectedValues1[0].name;
        } else {
            return "Select items";
        }
    };
    const getCandidates = async (companyId, page = 1, size = 10) => {
        console.log("DeptObjData", "1");

        try {
            const response = await axios.get(`/api/v1/candidates/?page=${page}&size=${size}`);
            const response_data = response.data.results
            if (response_data) {
                console.log(response_data);
                setcandidateListingData(response_data)


            } else {
            }
        } catch (error) {
        }
    }
    useEffect(() => {
        getCandidates()
    }, [])
    const AddCandidateForJobCall = () => { setAddCandidateModal(false); setInternalEmpSelectedValues1([]); setusersdrop([]); setActiveTab("upload"); setSelectedFiles([]) };

    const handleDeleteFile = (index) =>
        setSelectedFiles((prev) => prev.filter((_, i) => i !== index));

    const handleUpload = async () => {
        if (!selectedJobForUpload) return alert("No job selected!");
        setIsSubmitting(true);

        try {
            let payload = { job_id: selectedJobForUpload.job_id };

            // ✅ CASE 1: Upload resumes
            if (activeTab === "upload") {
                if (!selectedFiles.length) {
                    setIsSubmitting(false);
                    return alert("Please select at least one resume file!");
                }

                const attachments = await Promise.all(
                    selectedFiles.map(
                        (file) =>
                            new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    resolve({ file_name: file.name, file_data: reader.result.split(",")[1] });
                                };
                                reader.onerror = reject;
                                reader.readAsDataURL(file);
                            })
                    )
                );

                payload.attachments = attachments;
            }

            // ✅ CASE 2: Select existing candidates
            else if (activeTab === "existing") {
                if (!internalEmpSelectedValues1.length) {
                    setIsSubmitting(false);
                    return alert("Select at least one candidate!");
                }

                payload.candidate_ids = userDrop;
            }

            // ✅ API CALL
            const res = await axios.post(`/api/v1/candidates/upload-resumes/`, payload, {
                headers: { "Content-Type": "application/json" },
            });

            if (res.status === 200 || res.data?.status_code === 200) {
                // alert("Success!");
                setSelectedFiles([]);
                AddCandidateForJobCall();
                getJobOrders(companyId, 1);
                setErrorMessage("Candidate Added Successfully");
                setErrorAlert(true);
                setIsSuccess(true);
                getCandidateDetails(selectedJobForUpload.job_id)
            } else {
                // alert("Failed to process request.");
            }
        } catch (err) {
            console.error("Upload error:", err);
            // alert("Error processing request.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // ---------- delete job ----------
    const openDeleteJobModal = (job) => {
        setJobToDelete(job);
        setShowDeleteJobModal(true);
    };

    const confirmDeleteJob = async () => {
        setDeleteLoader(true);
        try {
            await axios.delete(
                `/api/v1/create-job-order/delete/?job_id=${jobToDelete.id}`
            );
            setShowDeleteJobModal(false);
            setDeleteLoader(false);
            await getJobOrders(companyId, 1);
            setErrorMessage("Job deleted successfully");
            setErrorAlert(true);
            setIsSuccess(true);
        } catch (err) {
            console.error("Delete job failed", err);
            setShowDeleteJobModal(false);
            setDeleteLoader(false);
            setErrorMessage("Failed to delete job");
            setErrorAlert(true);
            setIsSuccess(false);
        }
    };

    const confirmDeleteCandidate = async () => {
        setCandidateDeleteLoader(true);
        try {
            await axios.delete(
                `/api/v1/candidate-job-links/${candidateDeleteId}/`
            );
            console.log("hello")
            getCandidateDetails(selectedJobForUpload.job_id, 1);
            setShowDeleteCandidateModal(false);
            setCandidateDeleteLoader(false);
            setErrorMessage("Candidate deleted successfully");
            setErrorAlert(true);
            setIsSuccess(true);
        } catch (err) {
            console.error("Delete job failed", err);
            setShowDeleteCandidateModal(false);
            setCandidateDeleteLoader(false);
            setErrorMessage("Failed to delete candidate");
            setErrorAlert(true);
            setIsSuccess(false);
        }
    };

    // ---------- send test ----------
    const openSendTestModal = (candidate, job) => {
        setLoadingSendTest(true)
        setSendTestJobId(job.job_id ?? job.id);
        setSendTestCandidateId(candidate.candidate_id ?? candidate.id);
        handleSendTest(job.job_id ?? job.id, candidate.candidate_id ?? candidate.id);
    };

    const handleSendTest = async (jobId, candId) => {
        setLoadingSendTest(true);
        setLoadingSendTestCandidateId(candId)
        try {
            const payload = { job_id: jobId, candidate_id: candId };
            await axios.post(`/api/v1/screen/`, payload);
            // setShowSendTestModal(true);
            setErrorMessage("Test sent successfully");
            setErrorAlert(true);
            setIsSuccess(true);
        } catch (err) {
            console.error("Send test failed", err);
            setShowSendTestModal(false);
            setErrorMessage("Failed to send test");
            setErrorAlert(true);
            setIsSuccess(false);
        }
        finally {
        setLoadingSendTest(false);
        setLoadingSendTestCandidateId(null);
    }
    };

    const doSendTest = async () => {
        setShowSendTestModal(false);
    };

    // ---------- telephonic ----------
    const openTelephonicModal = (job) => {
        setTelephonicJob(job);
        setShowTelephonicModal(true);
    };

    const doTelephonicCall = async () => {
        try {
            // placeholder: call telephonic API if exists
            setShowTelephonicModal(false);
            setErrorMessage("Telephonic call logged");
            setErrorAlert(true);
            setIsSuccess(true);
        } catch (err) {
            console.error("telephonic error", err);
            setShowTelephonicModal(false);
            setErrorMessage("Telephonic call failed");
            setErrorAlert(true);
            setIsSuccess(false);
        }
    };

    // ---------- send to HRMS ----------
    const openHrmsModal = (candidate) => {
        setHrmsPayload(candidate);
        setShowHrmsModal(true);
    };

    const intialcompanydomain = userInfos?.user_details?.companies_data?.[0]?.company_domain ?? null;

    const [subdomain, setSubdomain] = useState(intialcompanydomain);


    const formatDate = (date) => {
        if (!date) return null;
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const doSendToHrms = async () => {
         setLoadingSendToHRMS(true); 
        try {
            console.log(hrmsPayload, "hrmsPayload");
            // Create a fresh axios instance — no global headers/interceptors will apply
            const hrmsAxios = axios.create();
            delete hrmsAxios.defaults.headers.common["Authorization"];

            const payload = {
                company: 1,
                first_name: hrmsPayload.first_name,
                last_name: hrmsPayload.last_name,
                personal_email: hrmsPayload.email,
                phone: hrmsPayload.mobile_phone,
                X_ATS_TOKEN: "ATS@123",
                date_of_join: joiningDate ? formatDate(joiningDate) : null,
                // date_of_join: "",
                // gender: ""
            };

            await hrmsAxios.post(
                `https://${subdomain}.bharatpayroll.com/qxbox/api/directory/add/new/employee/`,
                payload,
                {
                    headers: {

                        "Content-Type": "application/json",
                    },
                }
            );
            getHrmsstatus(hrmsPayload.candidate_id);
            setShowHrmsModal(false);
            setErrorMessage("Sent to HRMS");
            setErrorAlert(true);
            setIsSuccess(true);
        } catch (err) {
            console.error("send to hrms failed", err);
            setShowHrmsModal(false);
            setErrorMessage("Employee email/phone already exists in HRMS");
            setErrorAlert(true);
            setIsSuccess(false);
        }
        finally {
            setLoadingSendToHRMS(false); 
        }
    };
const [loadingSendTest, setLoadingSendTest] = useState(false);
const [loadingSendTestCandidateId, setLoadingSendTestCandidateId] = useState(null);

const [loadingSendToHRMS, setLoadingSendToHRMS] = useState(false);
const [loadingSendToHRMSCandidateId, setLoadingSendToHRMSCandidateId] = useState(null);

const [loadingDeleteCandidate, setLoadingDeleteCandidate] = useState(false);
const [loadingDeleteCandidateId, setLoadingDeleteCandidateId] = useState(null);


    const getHrmsstatus = async (candidate_id) => {
        console.log("candidate_idDeptObjData", candidate_id);

        try {
            const response = await axios.patch(`/api/v1/change-hrms-status/?page=1&size=10`, { candidate_id: candidate_id });
            const response_data = response.data.results
            if (response_data) {
                console.log(response_data);
                // setcandidateListingData(response_data)


            } else {
            }
        } catch (error) {
        }
    }


    // ---------- expandable components ----------
    const TestAndCallsExpansion = ({ data: candidate }) => {
        const tests = candidate?.talent_scan_result?.results ?? [];

        const columns = useMemo(
            () => [
                { name: "Test Name", selector: (r) => r.test_info?.name ?? "-" },
                {
                    name: "Designation",
                    selector: (r) => r.test_info?.test_designation ?? "-",
                },
                {
                    name: "Score",
                    selector: (r) =>
                        `${r.total_candidate_score ?? 0} / ${r.total_test_score ?? 0}`,
                },
                { name: "Percentage", selector: (r) => `${r.candidate_percentage_score ?? 0}%` },
                { name: "Is Attempted", selector: (r) => (r.is_attempted ? "Yes" : "No") },
                { name: "Is Submitted", selector: (r) => (r.is_submitted ? "Yes" : "No") },
                // {
                //     name: "Test Link",
                //     cell: (r) =>
                //         r.link ? (
                //             <a href={r.link} target="_blank" rel="noreferrer">
                //                 Open Test
                //             </a>
                //         ) : (
                //             "Not Available"
                //         ),
                // },
                  {
                            name: "View Result",
                            cell: (row) => {
                                const showButton = row?.id != null && row?.attempt_id != null;
                                console.log("testtest",showButton)
                                const handleViewResult = async () => {
                                    try {
                                        const payload = {
                                            assign_test_id: row.id,
                                            attempt_id: row.attempt_id
                                        };
                                        const response = await axios.post(
                                            "/api/v1/ts-view-test/create-dashboard-link/",
                                            payload,
                                        );
                                        if (response.data?.url) {
                                            window.open(response.data.url,"_blank");
                                        } else {
                                            Swal.fire("Error", "URL not found in response", "error");
                                        }
                                    } catch (err) {
                                        console.error(err);
                                        Swal.fire("Error", "Failed to generate link", "error");
                                    }
                                };
                
                                if (!showButton) return "-";
                                return (
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={handleViewResult}
                                    >
                                        View Result
                                    </button>
                                );
                            }
                        },
                // { name: "Action", cell: (r) => <RSButton outline size="sm">Resend</RSButton> },
            ],
            []
        );

        return (
            <div className="p-3 bg-white rounded border mt-2">
                <h6 className="mb-3">
                    Tests for{" "}
                    <strong>
                        {candidate.first_name ?? candidate.candidate_name ?? candidate.name}
                    </strong>
                </h6>

                {Array.isArray(tests) && tests.length > 0 ? (
                    <DataTable columns={columns} data={tests} dense highlightOnHover noHeader />
                ) : (
                    <p className="text-muted mb-0">No tests assigned.</p>
                )}
            </div>
        );
    };

    const CandidateExpansion = ({ data: job }) => {
        const jobId = job.id;
        const candidates = candidateDataMap[jobId] ?? [];

        // local search state to avoid losing focus while typing
        const [localSearch, setLocalSearch] = useState(searchMap[jobId] ?? "");

        // init per-job values if missing
        useEffect(() => {
            if (currentPageMap[jobId] === undefined)
                setCurrentPageMap((p) => ({ ...p, [jobId]: 1 }));
            if (perPageMap[jobId] === undefined) setPerPageMap((p) => ({ ...p, [jobId]: 10 }));
            if (totalRowsMap[jobId] === undefined) setTotalRowsMap((p) => ({ ...p, [jobId]: 0 }));
        }, [jobId]);

        // fetch candidates on first mount (if not cached)
        useEffect(() => {
            if (!candidateDataMap[jobId] && !loadingCandidatesMap[jobId]) {
                const page = getJobCurrentPage(jobId);
                const size = getJobPerPage(jobId);
                const search = searchMap[jobId] ?? "";
                getCandidateDetails(jobId, page, size, search);
            }
            // sync local input to last applied search
            setLocalSearch(searchMap[jobId] ?? "");
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [jobId]);

        const loadingCandidates = !!loadingCandidatesMap[jobId];

        const columns = useMemo(
            () => [
                {
                    name: "First Name",
                    selector: (r) => r.first_name ?? r.candidate_name ?? r.firstName,
                    sortable: true,
                },
                { name: "Last Name", selector: (r) => r.last_name ?? r.lastName },
                { name: "Email", selector: (r) => r.email ?? r.candidate_email ?? "" },
                { name: "Phone", selector: (r) => r.mobile_phone ?? r.candidate_phone ?? "" },
                // {
                //     name: "Designation",
                //     selector: (r) => r.designation ?? r.current_designation ?? "",
                // },
                // { name: "Company", selector: (r) => r.current_company ?? r.currentCompany ?? "" },
                { name: "Experience (Yrs)", selector: (r) => r.total_experience ?? r.experience ?? "" },
                // { name: "City", selector: (r) => r.city ?? "" },
                {
                    name: "Candidate Details",
                    cell: (row) => (
                        <div>
                            <span style={{ fontSize: "25px", fontWeight: "bold", cursor: "pointer" }} onClick={() => ViewCandidateInfo(row)}>
                                <FaRegEye />
                            </span>
                        </div>
                    ),
                },
                // {
                //     name: "Assigned Test",
                //     cell: (row) => (
                //         <div>
                //             <RSButton size="sm" outline onClick={() => console.log("view assigned test", row)}>
                //                 View
                //             </RSButton>
                //         </div>
                //     ),
                // },
                {
                    name: "Is Selected",
                    cell: (row) => {
                        const qualified =
                            row?.talent_scan_result?.results?.[0]?.ats_details?.is_test_qualified;

                        return (
                            <span
                                className={`badge px-2 py-1 ${qualified ? "bg-success" : "bg-danger"}`}
                                style={{ fontSize: "13px" }}
                            >
                                {qualified ? "Yes" : "No"}
                            </span>
                        );
                    },
                },

                            {
                  name: "Send Test",
                  cell: (row) => {
                      const isLoading = loadingSendTest && loadingSendTestCandidateId === row.candidate_id;
                      const isStandalone = userInfos.user_details?.companies_data?.some(
                          (c) => c.integration_type === "integrated-ts" || c.integration_type === "standalone"
                      );
                      const hasTalentScanResult = row?.talent_scan_result?.results?.length > 0;
              
                      return (
                          <div className="d-block w-100 text-center">
                              {hasTalentScanResult ? (
                                  <button
                                      className="btn btn-sm btn-outline-primary blueBtn"
                                      onClick={() => {
                                          if (isStandalone) {
                                              openSendTestModal(row, job);
                                          } else {
                                              openIntegratedPopup(row, job);
                                          }
                                      }}
                                      disabled={isLoading}
                                      title="Resend Test"
                                  >
                                      {isLoading ? (
                                          <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                          ></span>
                                      ) : (
                                          "Resend"
                                      )}
                                  </button>
                              ) : (
                                  <span
                                      style={{
                                          fontSize: "30px",
                                          fontWeight: "bold",
                                          cursor: "pointer",
                                      }}
                                      onClick={() => {
                                          if (isStandalone) {
                                              openSendTestModal(row, job);
                                          } else {
                                              openIntegratedPopup(row, job);
                                          }
                                      }}
                                      title="Send Test"
                                  >
                                      {isLoading ? (
                                          <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                          ></span>
                                      ) : (
                                          <IoIosSend />
                                      )}
                                  </span>
                              )}
                              {/* <Link
                                  className="btn btn-default"
                                  to="/candidate-time-line"
                                  style={{ fontSize: "24px" }}
                                  onClick={async (e) => {
                                      e.preventDefault();
                                      await fetchCandidateTimeline(row.candidate_id);
                                  }}
                                  title="Candidate Action Logs"
                              >
                                  <FaBusinessTime />
                              </Link> */}
                          </div>
                      );
                  },
              },
              {
                  name: "Action Logs",
                  cell: (row) => (
                      <Link
                          className="btn btn-default"
                          to="/candidate-time-line"
                          style={{ fontSize: "24px" }}
                          onClick={async (e) => {
                              e.preventDefault();
                              await fetchCandidateTimeline(row.candidate_id);
                          }}
                          title="Candidate Action Logs"
                      >
                          <FaBusinessTime />
                      </Link>
                  ),
              },
              
                {
                    name: "Send To Hrms",
                    // cell: (row) => (
                    //     <button className="btn blueBtn" onClick={() => openHrmsModal(row)}>
                    //         Send
                    //     </button >
                    // ),
                    cell: (row) => {
                        const isSentToHRMS = row.hrms_status; // hrms_status is true/false
                        return (
                            <button
                                className="btn blueBtn"
                                onClick={isSentToHRMS ? null : () => openHrmsModal(row)}
                                // disabled={isSentToHRMS}
                                disabled
                            >
                                {loadingSendToHRMS && loadingSendToHRMSCandidateId === row.candidate_id ? (
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                    "Send"
                                )}
                            </button>
                        );
                    },
                },
                // {
                //     name: "Action",
                //     // cell: (row) => (
                //     //     <div className="d-flex">
                //     //         {/* <Link to={`/create-job-orders-view/${job.id}`}>
                //     //             <RSButton color="light" size="sm">
                //     //                 <FaRegEdit />
                //     //             </RSButton>
                //     //         </Link> */}
                //     //         <button className="btn text-danger" size="sm" onClick={() => { handleCandidateDlink(row) }}>
                //     //             <FaRegTrashAlt />
                //     //         </button>
                //     //     </div>
                //     // ),
                //      cell: (row) => {
                //         const isSentToHRMS = row.hrms_status; // hrms_status is true/false
                //         return (
                //             <div className="d-flex">
                //                 <button
                //                     className="btn text-danger"
                //                     size="sm"
                //                     onClick={isSentToHRMS ? null : () => handleCandidateDlink(row)}
                //                     disabled={isSentToHRMS}
                //                 >
                //                     {loadingDeleteCandidate && loadingDeleteCandidateId === row.candidate_id ? (
                //                         <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                //                     ) : (
                //                         <FaRegTrashAlt />
                //                     )}
                //                 </button>
                //             </div>
                //         );
                //     },
                // },
            ],
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [job.id]
        );

        return (
            <div className="bg-light rounded">
                <Row className="mb-2 mx-0">
                    <Col xxl={12}>
                        <h6 className="mb-3 pt-3">
                            Candidates for <strong>{job.job_title}</strong>
                        </h6>
                    </Col>
                </Row>

                <Row className="mb-2 mx-0">
                    <Col xxl={3} lg={6} md={12}>
                        <div className="d-flex">
                            <Input
                                placeholder="Search with Name and Email"
                                value={localSearch}
                                onChange={(e) => setLocalSearch(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        setSearchMap((p) => ({ ...p, [jobId]: localSearch }));
                                        handleCandidateSearch(jobId, localSearch);
                                    }
                                }}
                                autoComplete="off"
                            />

                            <Button
                                className="btn searchIconBtn import-res-btn"
                                onClick={() => {
                                    setSearchMap((p) => ({ ...p, [jobId]: localSearch }));
                                    handleCandidateSearch(jobId, localSearch);
                                }}
                            >
                                <i className="fa fa-search" />
                            </Button>
                        </div>
                    </Col>
                </Row>

                <Row className="mx-0">
                    <Col xxl={12}>
                        {loadingCandidates ? (
                            <p className="text-muted">Loading candidates...</p>
                        ) : !Array.isArray(candidates) || candidates.length === 0 ? (
                            <p className="text-muted mb-0 pb-3">No candidates added yet.</p>
                        ) : (
                            <div id="CandidateTest_DataTableView">
                                <DataTable
                                    columns={columns}
                                    data={Array.isArray(candidates) ? candidates : []}
                                    expandableRows
                                    expandableRowsComponent={TestAndCallsExpansion}
                                    highlightOnHover
                                    pagination
                                    dense
                                    paginationServer
                                    paginationTotalRows={getJobTotalRows(jobId)}
                                    paginationDefaultPage={getJobCurrentPage(jobId)}
                                    paginationPerPage={getJobPerPage(jobId)} // important to show selected per page
                                    paginationRowsPerPageOptions={[10, 15, 20, 50]}
                                    onChangePage={(page) => handlePageChangeForJob(jobId, page)}
                                    onChangeRowsPerPage={(newPerPage, page) =>
                                        handlePerRowsChangeForJob(jobId, newPerPage, page)
                                    }
                                    onSelectedRowsChange={(state) => {
                                        /* keep behavior - store selected if needed */
                                    }}
                                />
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        );
    };

    // ---------- job table columns ----------
    const jobColumns = useMemo(
        () => [
            {
                name: <span className="fs-6 fw-bold">Job Title</span>,
                selector: (r) => r.job_title ?? r.position ?? r.job_order_id,
                sortable: true,
            },
            {
                name: <span className="fs-6 fw-bold">Job ID</span>,
                selector: (r) => r.job_order_id ?? r.job_number ?? r.id,
                sortable: true,
            },
             {
                name: <span className="fs-6 fw-bold">Category</span>,
                selector: r =>
                    r.category_name ? r.category_name : "-",
                sortable: true,
            },
             {
                name: <span className="fs-6 fw-bold">Created By</span>,
                selector: r =>
                    r.created_by_name ? (r.created_by_name): "-",
                sortable: true,
            },
            {
                name: <span className="fs-6 fw-bold">Handled By</span>,
                cell: row => (
                    <span title={row.recruiters_names?.join(", ") ?? "-"}>
                        {row.recruiters_names?.join(", ") ?? "-"}
                    </span>
                ),
                sortable: true,
            },
            {
                name: <span className="fs-6 fw-bold">Created At</span>,
                selector: (r) => (r.created_at ? new Date(r.created_at).toLocaleString() : "-"),
                sortable: true,
            },
            {
                name: <span className="fs-6 fw-bold">Updated At</span>,
                selector: (r) => (r.updated_at ? new Date(r.updated_at).toLocaleString() : "-"),
                sortable: true,
            },
            {
                name: <span className="fs-6 fw-bold">Archived At</span>,
                selector: (r) => (r.archived_at ? new Date(r.archived_at).toLocaleString() : "-"),
                sortable: true,
            },
            {
                name: <span className="fs-6 fw-bold">Archived By</span>,
                selector: (r) => (r.archived_by_name ? r.archived_by_name: "-"),
                sortable: true,
            },
            {
                name: <span className="fs-6 fw-bold">Status</span>,
                cell: (row) => (
                    <div className="d-flex align-items-center gap-2">
                        {row.job_status_name}
                        {/* <FaPencilAlt
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setSelectedJobForStatus(row);
                                setSelectedStatusId(row.job_status_id ?? "");
                                setStatusModal(true);
                            }}
                        /> */}
                    </div>
                ),
            },
            // {
            //     name: <span className="fs-6 fw-bold">Add Candidate</span>,
            //     cell: (row) => (
            //         <button
            //             className="btn btn-sm addBtn"
            //             onClick={() => {
            //                 setSelectedJobForUpload(row);
            //                 setAddCandidateModal(true);
            //                 setExpandedRowId(row.job_id)
            //             }}
            //         >
            //             Add Candidate
            //         </button>
            //     ),
            // },


            {
                name: <span className="fs-6 fw-bold">View Candidates</span>,
                cell: (row) => (
                    <button
                        className="btn btn-sm addBtn"
                        onClick={() =>
                            navigate("/candidate-details-view", {
                                state: { job_id: row.job_id ?? row.id, companyId },
                            })
                        }
                    >
                        View Candidates
                    </button>
                ),
            },
            // {
            //     name: <span className="fs-6 fw-bold">Action</span>,
            //     cell: (row) => (
            //         <div className="d-flex gap-2">
            //             <Link to={`/create-job-orders-view/${row.id}`}>
            //                 <RSButton color="light" size="sm">
            //                     <FaRegEdit />
            //                 </RSButton>
            //             </Link>
            //             <RSButton color="light" size="sm" onClick={() => openDeleteJobModal(row)}>
            //                 <FaRegTrashAlt />
            //             </RSButton>
            //         </div>
            //     ),
            // },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [companyId, jobStatusList]
    );

    const [expandedRowId, setExpandedRowId] = useState(null);
    const [statusError, setstatusError] = useState("");
    const [statusLoader, setstatusLoader] = useState(false);

    const handleStatusUpdate = async () => {
        setstatusLoader(true);

        if (!selectedStatusId) {
            setstatusLoader(false);
            return setstatusError("Select a status");
        }

        try {
            await axios.patch(`/api/v1/jobs/${selectedJobForStatus.job_id}/change-status/`, {
                status: selectedStatusId,
            });

            // ✅ Trigger UI alert BEFORE closing modal
            setErrorMessage("Status updated successfully");
            console.log("hjgjhg")
            setIsSuccess(true);
            setErrorAlert(true);

            setStatusModal(false);
            setstatusLoader(false);
            setstatusError("")
            await getJobOrders(companyId, currentPage, perPage);

        } catch (err) {
            console.error(err);
            setstatusLoader(false);
            setstatusError("")

            setErrorMessage("Failed to update status");
            setIsSuccess(false);
            setErrorAlert(true);
        }
    };


    const handleCompanyChange = (company) => {
        console.log(company)
        // setSelectedCompany(company);
        if (company?.company_id) {
            setSubdomain(company.company_domain);
        }
    };
        const [resetLoading, setResetLoading] = useState(false);
    
    useEffect(() => {
        if (jobSearchText === "") {
            getJobOrders(companyId, 1, perPage).finally(() => {
                setResetLoading(false);
            });
        }
    }, [jobSearchText]);

    // ---------- render ----------
    return (
        <>
            <div className="container-fluid p-3">
                <div className="row mb-3 mx-0">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <h4 className="mb-0">Job Orders</h4>
                        <div />
                    </div>
                </div>

                <div className="d-flex flex-wrap w-100 px-2 gap-2">
                    {/* Status Filter Dropdown */}
                    <div>
                        <Input
                            type="select"
                            value={selectedStatusIdFilter}
                            onChange={(e) => setSelectedStatusIdFilter(e.target.value)}
                            className="form-select mt-5"
                        >
                            <option value="">-- Select Status --</option>
                            {/* {jobStatusList.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.job_status}
                                </option>
                            ))} */}
                            {jobStatusList
                                .filter((item) => item.job_status !== "Approved / Open")
                                .map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.job_status}
                                    </option>
                            ))}
                        </Input>
                    </div>
                     <div>
                    <Input
                        type="select"
                        value={selectedCategoryName}
                        onChange={(e) => setSelectedCategoryName(e.target.value)}
                        className="form-select mt-5"
                    >
                        <option value="">-- Select Category --</option>
                        {testTypeList.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </Input>
                </div>

                    <div className="d-flex ms-auto flex-wrap gap-2">
                        <div className="mt-5">
                            <div className="d-flex justify-content-end">
                                <label className="mt-2">Select Company</label>
                                <div className="mb-2 mx-2" style={{ width: "170px" }}>
                                    <CompanySelector onCompanyChange={(c) => { setCompanyId(c?.company_id ?? null); }} />
                                </div>
                            </div>
                        </div>

                        <div style={{ width: "220px" }} className="mt-5">
                            <InputGroup>
                            <Input
                                placeholder="Search with job title"
                                value={jobSearchText}
                                onChange={e => {
                                const value = e.target.value;
                                setJobSearchText(value);
                                if (value === "") {
                                // getJobOrders(companyId, 1, perPage,);
                                }
                            }}
                            onKeyDown={e => {
                                if (e.key === "Enter") handleJobSearch(jobSearchText);
                            }}
                            />
                                {jobSearchText !== "" && (
                            <InputGroupText
                                style={{
                                cursor: "pointer",
                                background: "transparent",
                                borderLeft: "none"
                                }}
                                onClick={() => {
                                    setResetLoading(true);
                                    setJobSearchText("");
                                    // getJobOrders(companyId, 1, perPage,);
                                }}
                            >
                                <FaTimes style={{ fontSize: "14px", color: "#6c757d" }} />
                            </InputGroupText>
                            )}
                            <Button
                                className="btn searchIconBtn import-res-btn"
                                onClick={handleJobSearch}
                            >
                                <i className="fa fa-search" />
                            </Button>
                        </InputGroup>
                        </div>


                        {/* <div>
                            <button
                                type="button"
                                className="btn border-0 blueBtn mt-5"
                                onClick={() => navigate(`/create-job-orders-view`)}
                            >
                                Create Job Order
                            </button>
                        </div> */}
                    </div>
                </div>

                <div className="card p-3 border-0" id="JobOrderTableView">
                    <DataTable
                        columns={jobColumns}
                        data={Array.isArray(jobOrdersData) ? jobOrdersData : []}
                        progressPending={loadingJobs}
                        expandableRows
                        expandableRowsComponent={CandidateExpansion}
                        highlightOnHover
                        pagination
                        persistTableHead
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationDefaultPage={currentPage}
                        paginationPerPage={perPage} // top-level table per page
                        paginationRowsPerPageOptions={[10, 15, 20, 50]}
                        onChangeRowsPerPage={async (newPerPage, page) => {
                            if (perPage !== newPerPage) {
                                setCurrentPage(1);
                                page = 1;
                            }
                            setPerPage(newPerPage === -1 ? totalRows : newPerPage);
                            await getJobOrders(companyId, page, newPerPage === -1 ? totalRows : newPerPage);
                        }}
                        onChangePage={async (page) => {
                            setCurrentPage(page);
                            await getJobOrders(companyId, page, perPage);
                        }}
                        onSelectedRowsChange={(state) => setSelectedJobs(state.selectedRows || [])}
                        expandableIcon={{
                            collapsed: (
                                <span style={{ fontSize: "18px", fontWeight: "bold" }} className="expander-bubble">
                                    <FaPlus />
                                </span>
                            ),
                            expanded: (
                                <span style={{ fontSize: "18px", fontWeight: "bold" }} className="expander-bubble">
                                    <FaMinus />
                                </span>
                            ),
                        }}
                        expandableRowExpanded={(row) => row.job_id === expandedRowId}
                        fixedHeader
                        fixedHeaderScrollHeight="450px"
                        fixedHeaderScrollWidth="50px"
                        subHeader
                        paginationComponentOptions={paginationComponentOptions}
                        progressComponent={<OrgTableShimmer columns={6} rows={6} titleWidth="210px" />}
                    />
                </div>
            </div>

    

            {/* ---------- Delete Job Confirmation Modal ---------- */}
            <Modal isOpen={showDeleteJobModal} toggle={() => setShowDeleteJobModal(!showDeleteJobModal)}>
                <ModalHeader toggle={() => setShowDeleteJobModal(!showDeleteJobModal)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
                    Confirm Delete
                </ModalHeader>
                <ModalBody>
                    Are you sure you want to delete job <strong>{jobToDelete?.job_title}</strong>?
                </ModalBody>
                <ModalFooter className="justify-content-center">
                    <RSButton color="secondary" onClick={() => setShowDeleteJobModal(false)}>
                        Cancel
                    </RSButton>
                    <RSButton color="danger" onClick={confirmDeleteJob} disabled={deleteLoader}>
                        {deleteLoader ? "Deleting.." : "Delete"}
                    </RSButton>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showDeleteCandidateModal} toggle={() => setShowDeleteCandidateModal(!showDeleteCandidateModal)}>
                <ModalHeader toggle={() => setShowDeleteCandidateModal(!showDeleteCandidateModal)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
                    Confirm Delete
                </ModalHeader>
                <ModalBody >
                    <span className="justify-content-center">

                        Are you sure you want to delete candidate?
                    </span>
                </ModalBody>
                <ModalFooter className="justify-content-center">
                    <RSButton color="secondary" onClick={() => setShowDeleteCandidateModal(false)}>
                        Cancel
                    </RSButton>
                    <RSButton color="danger" onClick={confirmDeleteCandidate} disabled={CandidateDeleteLoader}>
                        {CandidateDeleteLoader ? "Deleting.." : "Delete"}
                    </RSButton>
                </ModalFooter>
            </Modal>

            {/* ---------- Send Test Modal ---------- */}
            <Modal isOpen={showSendTestModal} toggle={() => setShowSendTestModal(false)}>
                <ModalHeader toggle={() => setShowSendTestModal(false)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
                    Send Test
                </ModalHeader>
                <ModalBody>
                    <p>Test sent successfully</p>
                </ModalBody>
                <ModalFooter className="justify-content-center">
                    <RSButton color="secondary" onClick={() => setShowSendTestModal(false)}>
                        Ok
                    </RSButton>
                </ModalFooter>
            </Modal>

            {/* ---------- Telephonic Call Modal ---------- */}
            <Modal isOpen={showTelephonicModal} toggle={() => setShowTelephonicModal(!showTelephonicModal)}>
                <ModalHeader toggle={() => setShowTelephonicModal(false)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
                    Telephonic Call
                </ModalHeader>
                <ModalBody>
                    <p>Telephonic call logged for <strong>{telephonicJob?.job_title}</strong></p>
                </ModalBody>
                <ModalFooter className="justify-content-center">
                    <RSButton color="secondary" onClick={() => setShowTelephonicModal(false)}>
                        Ok
                    </RSButton>
                </ModalFooter>
            </Modal>

            {/* ---------- Send to HRMS Modal ---------- */}
            <Modal isOpen={showHrmsModal} toggle={() => setShowHrmsModal(!showHrmsModal)}>
                <ModalHeader toggle={() => setShowHrmsModal(false)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
                    Send to HRMS
                </ModalHeader>
                <ModalBody>
                    <p>Send <strong>{hrmsPayload?.first_name ?? hrmsPayload?.candidate_name}</strong> to HRMS?</p>
                    <Label for="DesignationInput" className="d-block">
                        Company <span className="text-danger">*</span>
                    </Label>
                    <CompanySelector onCompanyChange={handleCompanyChange} selectedCompanyId={companyId} />

                    <Col>
                        <div >
                            <Label for="dateOfJoin" className="d-block">
                                Date of Join <span className="text-danger">*</span>
                            </Label>
                            <DatePicker
                                id="dateOfJoin"
                                className="form-control"
                                selected={joiningDate}
                                onChange={(date) => setJoiningDate(date)}
                                minDate={new Date()} // only current & future dates
                                dateFormat="dd-MM-yyyy"
                                placeholderText="Select Date of Join"
                            />
                        </div>
                    </Col>
                </ModalBody>
                <ModalFooter className="justify-content-center">
                    <RSButton color="secondary" onClick={() => setShowHrmsModal(false)}>Cancel</RSButton>
                    {/* <RSButton color="primary" onClick={doSendToHrms}>Send</RSButton> */}
                    <RSButton
                        color="primary"
                        onClick={doSendToHrms}
                        disabled={loadingSendToHRMS}
                    >
                        {loadingSendToHRMS ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending...
                        </>
                        ) : (
                        "Send"
                        )}
                    </RSButton>
                </ModalFooter>
            </Modal>

            {/* ---------- Status Modal ---------- */}
            <Modal isOpen={statusModal} toggle={() => setStatusModal(false)}>
                <ModalHeader toggle={() => { setStatusModal(false); setstatusError("") }} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
                    Update Status
                </ModalHeader>
                <ModalBody>
                    <label className="fw-bold mt-4">Select Status</label>
                    <Input type="select" value={selectedStatusId} onChange={(e) => { setSelectedStatusId(e.target.value); setstatusError("") }} className="mb-4">
                        <option value="">-- Select --</option>
                        {jobStatusList.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.job_status}
                            </option>
                        ))}
                    </Input>
                    <small className="text-danger">{statusError}</small>
                </ModalBody>

                <ModalFooter className="justify-content-center">
                    <button className="btn blueBtn" onClick={() => { setStatusModal(false); setstatusError("") }}>
                        Cancel
                    </button>
                    <button className="btn addBtn" onClick={handleStatusUpdate} disabled={statusLoader}>
                        {statusLoader ? "Updating.." : "Update"}
                    </button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={ViewCandidatePopupShow}
                toggle={() => setViewCandidatePopupShow(false)}
                size="xl"
                className="candidate-modal"
            >
                <ModalHeader toggle={() => setViewCandidatePopupShow(false)} className="bg-light border-0">
                    <h4 className="mb-0 text-dark fw-semibold">
                        {selectedCandidate?.first_name} {selectedCandidate?.last_name}
                    </h4>
                </ModalHeader>

                <ModalBody className="p-4" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <Card body className="border-0 shadow-sm rounded-4">
                        <Row className="g-4">
                            {/* Candidate Info Fields */}
                            <Col md={6}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">First Name :</strong>{" "}
                                    <span className="text-dark">{selectedCandidate?.first_name || "—"}</span>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Last Name :</strong>{" "}
                                    <span className="text-dark">{selectedCandidate?.last_name || "—"}</span>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Total Experience :</strong>{" "}
                                    <span className="text-dark">{selectedCandidate?.total_experience} Years</span>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Email :</strong>{" "}
                                    <span className="text-dark">{selectedCandidate?.email || "—"}</span>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Phone :</strong>{" "}
                                    <span className="text-dark">{selectedCandidate?.mobile_phone || "—"}</span>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Current Company :</strong>{" "}
                                    <span className="text-dark">{selectedCandidate?.current_company || "—"}</span>
                                </div>
                            </Col>

                            {/* <Col md={12}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Primary Skills :</strong>{" "}
                                    <span className="badge text-bg-warning ms-2">
                                        {selectedCandidate?.primary_skills?.join(", ") || "—"}
                                    </span>
                                </div>
                            </Col>


                            <Col md={12}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Secondary Skills :</strong>{" "}
                                    <span className="badge text-bg-warning ms-2">
                                        {selectedCandidate?.secondary_skill_names?.join(", ") || "—"}
                                    </span>
                                </div>
                            </Col>

                            <Col md={12}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Other Skills :</strong>{" "}
                                    <span className="badge text-bg-warning ms-2">
                                        {selectedCandidate?.other_skill_names?.join(", ") || "—"}
                                    </span>
                                </div>
                            </Col> */}
                            <Col md={12}>
                            <div
                                style={{
                                border: "1px solid #dee2e6",
                                borderRadius: "10px",
                                padding: "0.9rem 1rem",
                                backgroundColor: "#fdfdfd",
                                }}
                            >
                                <strong style={{ color: "#6c757d" }}>Primary Skills:</strong>
                                {selectedCandidate?.primary_skills && selectedCandidate.primary_skills.length > 0 ? (
                                selectedCandidate.primary_skills.map((skill, i) => (
                                    <span
                                    key={i}
                                    style={{
                                        backgroundColor: "#e9ecef",
                                        color: "#212529",
                                        padding: "0.35rem 0.75rem",
                                        borderRadius: "8px",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                        marginLeft: "0.5rem",
                                        display: "inline-block",
                                        marginBottom: "0.4rem",
                                    }}
                                    >
                                    {skill}
                                    </span>
                                ))
                                ) : (
                                <span style={{ color: "#212529", marginLeft: "0.5rem" }}>—</span>
                                )}
                            </div>
                            </Col>

                            <Col md={12}>
                            <div
                                style={{
                                border: "1px solid #dee2e6",
                                borderRadius: "10px",
                                padding: "0.9rem 1rem",
                                backgroundColor: "#fdfdfd",
                                }}
                            >
                                <strong style={{ color: "#6c757d" }}>Secondary Skills:</strong>
                                {selectedCandidate?.secondary_skill_names && selectedCandidate.secondary_skill_names.length > 0 ? (
                                selectedCandidate.secondary_skill_names.map((skill, i) => (
                                    <span
                                    key={i}
                                    style={{
                                        backgroundColor: "#e9ecef",
                                        color: "#212529",
                                        padding: "0.35rem 0.75rem",
                                        borderRadius: "8px",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                        marginLeft: "0.5rem",
                                        display: "inline-block",
                                        marginBottom: "0.4rem",
                                    }}
                                    >
                                    {skill}
                                    </span>
                                ))
                                ) : (
                                <span style={{ color: "#212529", marginLeft: "0.5rem" }}>—</span>
                                )}
                            </div>
                            </Col>

                            <Col md={12}>
                            <div
                                style={{
                                border: "1px solid #dee2e6",
                                borderRadius: "10px",
                                padding: "0.9rem 1rem",
                                backgroundColor: "#fdfdfd",
                                }}
                            >
                                <strong style={{ color: "#6c757d" }}>Other Skills:</strong>
                                {selectedCandidate?.other_skill_names && selectedCandidate.other_skill_names.length > 0 ? (
                                selectedCandidate.other_skill_names.map((skill, i) => (
                                    <span
                                    key={i}
                                    style={{
                                        backgroundColor: "#e9ecef",
                                        color: "#212529",
                                        padding: "0.35rem 0.75rem",
                                        borderRadius: "8px",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                        marginLeft: "0.5rem",
                                        display: "inline-block",
                                        marginBottom: "0.4rem",
                                    }}
                                    >
                                    {skill}
                                    </span>
                                ))
                                ) : (
                                <span style={{ color: "#212529", marginLeft: "0.5rem" }}>—</span>
                                )}
                            </div>
                            </Col>
                            {/* <Col md={12}>
                                <div className="border rounded p-3 bg-light-subtle">
                                    <strong className="text-secondary">Resume :</strong>{" "}
                                    {selectedCandidate?.resume ? (
                                        <a
                                            href={selectedCandidate?.resume}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="fw-semibold text-success text-decoration-none ms-2"
                                        >
                                            View Resume <i className="bi bi-box-arrow-up-right ms-1"></i>
                                        </a>
                                    ) : (
                                        <span className="text-dark">—</span>
                                    )}
                                </div>
                            </Col> */}
                        </Row>
                    </Card>
                </ModalBody>

                <ModalFooter className="border-0">
                    <Button color="secondary" onClick={() => setViewCandidatePopupShow(false)} className="px-4">
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            <SuccessErrorPopup
                show={errorAlert}
                handleClose={handleCloseErrorModal}
                errorMessage={errorMessage}
                isSuccess={isSuccess}
            />
        </>
    );
};

export default ArchivedJobOrders
